module.exports = __webpack_public_path__ + "img/emoji_32.388aa9a4.png";